export enum AssetGalleryLayout {
	CARD = 'card',
	CURATOR = 'curator',
	GRID = 'grid',
	LIST = 'list',
}

export enum AssetGalleryPref {
	CARD_SIZE = 'asset.list.cardSize',
	CARD_SIZE_PORTAL = 'brandPortal.asset.list.cardSize',
	CURATOR_MODE = 'asset.list.curatorMode',
	LAYOUT = 'asset.list.type',
	LAYOUT_PORTAL = 'brandPortal.asset.list.type',
	SORT_FIELD = 'asset.list.sort.field',
	SORT_ORDER = 'asset.list.sort.order',
	SORT_FIELD_PORTAL = 'brandPortal.asset.list.sort.field',
	SORT_ORDER_PORTAL = 'brandPortal.asset.list.sort.order',
	SIDEPANE_OPEN = 'asset.sidepane.open',
}

const AssetGallerySelectedAttributeSetPrefPrefix =
	'attribute.attributeSets.selected.gallery';

export enum AssetGallerySelectedAttributeSetPref {
	CARD = `${AssetGallerySelectedAttributeSetPrefPrefix}.card`,
	CURATOR = `${AssetGallerySelectedAttributeSetPrefPrefix}.curator`,
	LIST = `${AssetGallerySelectedAttributeSetPrefPrefix}.list`,

	// CARD_PORTAL = `brandPortal.${AssetGallerySelectedAttributeSetPrefPrefix}.card`,
	// LIST_PORTAL = `brandPortal.${AssetGallerySelectedAttributeSetPrefPrefix}.list`,
}
